import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Route, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule, AlertModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap';

import { AppComponent } from './app.component';
import { FullLayoutComponent } from './full-layout/full-layout.component';
import { NavigationComponent } from './full-layout/navigation/navigation.component';
import { HeaderComponent } from './full-layout/header/header.component';
import { FooterComponent } from './full-layout/footer/footer.component';
import { PatientListComponent } from './patient-list/patient-list.component';
import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';


import { RestService } from './services/rest.service';
import { LoginService } from './services/login.service';
import { AuthGuard } from './services/auth-guard.service';
import { NextExaminationListComponent } from './next-examination-list/next-examination-list.component';
import { InvoiceComponent } from './invoice/invoice.component';
import { InvoiceService } from './services/invoice.service';
import { LoadingIndicatorService } from './services/loading-indicator.service';


@NgModule({
  declarations: [
    AppComponent,
    FullLayoutComponent,
    NavigationComponent,
    HeaderComponent,
    FooterComponent,
    PatientListComponent,
    LoginComponent,
    PageNotFoundComponent,
    NextExaminationListComponent,
    InvoiceComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    Ng2TableModule,
    PaginationModule.forRoot() ,
    AlertModule.forRoot(),
    TabsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule


  ],
  providers: [RestService, LoginService, AuthGuard, InvoiceService, LoadingIndicatorService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /home/usr/clienti.qmedical/src/app/app.module.ts